import React, { useState } from 'react';
import InputMask from 'react-input-mask';

const TelefoneInput = ({ nif, setNif }) => {
    return (
        <InputMask
            mask="999.999.999-99"
            value={nif}
            onChange={e => setNif(e.target.value)}
        >
            {(inputProps) => (
                <input
                    {...inputProps}
                    type="text"
                    id="username"
                    className="inputCodigo"
                    placeholder="Digite o CPF do Aluno"
                />
            )}
        </InputMask>
    );
};

export default TelefoneInput;
